import { render } from "./cms-info-area.vue?vue&type=template&id=7567b6ae"
import script from "./cms-info-area.vue?vue&type=script&lang=js"
export * from "./cms-info-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__